import { Config } from 'src/apis/config'

class AppTheme {
  config: Config = <Config>{}

  init(config: Config) {
    this.config = config

    this.setTitle()
    this.setColor()
  }

  setColor() {
    document.documentElement.style.setProperty('--q-primary', this.config.color)
  }

  setTitle() {
    document.title = this.config.name
    if (this.config.description) {
      document.title += ` | ${this.config.description}`
    }
  }

  getConfig(): Config {
    return this.config
  }

  getColor(): string {
    return this.config.color
  }

  getLogo(): string {
    return this.config.image
  }

  getProfileConfig() {
    return {
      firstName: this.config.profileConfig.firstName,
      lastName: this.config.profileConfig.firstName,
      gender: this.config.profileConfig.gender,
      email: this.config.profileConfig.email,
      birthdate: this.config.profileConfig.birthdate,
      address: this.config.profileConfig.address,
      branch: this.config.profileConfig.branch,
    }
  }
}

export const appTheme = new AppTheme()
